import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyVideoBackgroundLayout = loadable(() => import(/* webpackChunkName: "content/guest/header/videoBackground" */ './VideoBackground'), 'VideoBackgroundLayout');
